export function formatCurrency(value: number | string | undefined | null): string {
  const num = Number(value ?? 0);
  return `₦${num.toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const CURRENCY_SYMBOL = "₦";
